import DOMPurify from 'dompurify';

const CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'strike',
    'h1',
    'h2',
    'h3',
    'h4',
    'ul',
    'ol',
    'li',
    'a',
    'span',
    'blockquote',
    'div',
    'section',
    'pre',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
  ALLOW_DATA_ATTR: false,
};

/** Sanitize CMS HTML (Quill output) for safe rendering on public pages. */
export function sanitizeI3Html(html: string): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, CONFIG);
}
